import axiosInstance from '@/network';
import { isMockBackend } from '@/utils';
import { useQuery } from '@tanstack/react-query';
import schema from '@/schemas/product-trace';
import useStore, { selectFavoriteCountryId, selectSetBatchData } from '../client/useStore';
import { transformData } from '@/transformations/data-transformations.js';

const parseData = (res) => {
  const parseResult = schema.safeParse(res);
  console.log({ CountryConfigurations: parseResult?.error?.issues });
  return parseResult.success ? parseResult.data : null;
};

const useProductTrace = (production_lot, enabled) => {
  const favoriteCountryId = useStore(selectFavoriteCountryId);
  const setBatchData = useStore(selectSetBatchData);

  return useQuery({
    queryKey: ['production-lot'],
    queryFn: async () => {
      if (!production_lot || !favoriteCountryId) return null;

      try {
        if (isMockBackend) {
          const response = await fetch(`/data/${favoriteCountryId}/production-lots.json`);
          if (!response.ok) {
            throw new Error(`No se pudo cargar el archivo del lote.`);
          }
          const res = await response.json();
          const filtered = res?.find(
            (item) => item.production_lot === production_lot.toUpperCase(),
          );

          const parseResult = parseData(filtered);
          const transformedData = transformData(parseResult, favoriteCountryId);

          setBatchData(transformedData || null);
          return transformedData || null;
        }

        const res = await axiosInstance.get(
          `/product-traces/${favoriteCountryId}/${production_lot}`,
        );

        const transformedData = transformData(res.data, favoriteCountryId);

        setBatchData(transformedData || null);
        return transformedData || null;
      } catch (err) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const status = err?.response?.status;
        if (status === 400 || status === 404) {
          setBatchData(null);
          return null;
        }
        setBatchData(null);
        console.error('Error loading product-trace:', err);
      }
    },
    enabled,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export default useProductTrace;
